import { Component, NgZone, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { InmediatePendingOrdersService, PendingOrdersServiceData } from "../../services/ordersKpi/pendingOrders.service";
import { PendingOrdersDetailServiceData } from "../../services/ordersKpi/pendingOrdersDetail.service";
import { PermInmediatePendingOrdersDetailService } from "../../services/ordersKpi/permPendingOrdersDetail.service";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";
import { PendingOrdersData } from "./pendingOrdersData";

@Component({
    selector: 'inmediate-pending-orders-perm-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class InmediatePendingOrdersPermKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<InmediatePendingOrdersService, PendingOrdersServiceData, PendingOrdersData, PermInmediatePendingOrdersDetailService, PendingOrdersDetailServiceData, PendingOrdersDetailServiceData>  
    implements OnDestroy {
    public getClassName() { return "InmediatePendingOrdersPermKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: InmediatePendingOrdersService, detailService: PermInmediatePendingOrdersDetailService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: PendingOrdersServiceData): PendingOrdersData {
        return new PendingOrdersData(
            data.consultantBucketPermanent + data.consultantNoBucketPermanent,
            data.consultantBucketPermanent,
            data.officeBucketPermanent + data.officeNoBucketPermanent,
            data.officeBucketPermanent
        );
    }

    protected getDefaultSummaryData(): PendingOrdersData {
        let data = new PendingOrdersData(0, 0, 0, 0);
        return data;
    }

    protected extractUpdateTime(data: PendingOrdersServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: PendingOrdersDetailServiceData): PendingOrdersDetailServiceData {
        return data;
    }

    protected performDetailAction(): void {
        if (this.detailData) window.open(this.detailData.link, "_blank");
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }
}